import { Button, cn } from "@zaphub/ui";
import { Building2, Gauge, History, LogOut, Moon, Package, Settings, Smartphone, Sun, Tags } from "lucide-react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";

import { Logo } from "../components/Logo";
import { api } from "../lib/api";
import { useSessao } from "../lib/sessao";
import { useTema } from "../lib/tema";

const ITENS = [
  { para: "/plataforma", rotulo: "Visão geral", icone: Gauge, fim: true },
  { para: "/plataforma/contas", rotulo: "Contas", icone: Building2 },
  { para: "/plataforma/planos", rotulo: "Planos", icone: Package },
  { para: "/plataforma/numeros", rotulo: "Números", icone: Smartphone },
  { para: "/plataforma/precos-meta", rotulo: "Preços Meta", icone: Tags },
  { para: "/plataforma/configuracoes", rotulo: "Configurações", icone: Settings },
  { para: "/plataforma/auditoria", rotulo: "Auditoria", icone: History },
] as const;

/** Casca da área administrativa (SUPERADMIN). */
export default function PlataformaLayout() {
  const { usuario, limpar } = useSessao();
  const { tema, alternar } = useTema();
  const navegar = useNavigate();

  const sair = async () => {
    try {
      await api.post("/auth/logout");
    } finally {
      limpar();
      navegar("/entrar", { replace: true });
    }
  };

  return (
    <div className="min-h-screen lg:grid lg:grid-cols-[15rem_1fr]">
      <aside className="border-b bg-card lg:min-h-screen lg:border-b-0 lg:border-r">
        <div className="p-4">
          <Logo />
          <p className="mt-1 text-xs uppercase tracking-wider text-muted-foreground">Plataforma</p>
        </div>
        <nav aria-label="Plataforma" className="flex gap-1 overflow-x-auto px-2 pb-2 lg:flex-col lg:overflow-visible">
          {ITENS.map(({ para, rotulo, icone: Icone, ...resto }) => (
            <NavLink
              key={para}
              to={para}
              end={"fim" in resto}
              className={({ isActive }) =>
                cn(
                  "flex items-center gap-2.5 whitespace-nowrap rounded-md px-3 py-2 text-sm text-muted-foreground transition-colors hover:bg-muted hover:text-foreground",
                  isActive && "bg-muted font-medium text-foreground",
                )
              }
            >
              <Icone className="size-4" />
              {rotulo}
            </NavLink>
          ))}
        </nav>
      </aside>
      <div className="flex min-w-0 flex-col">
        <header className="flex items-center justify-end gap-2 border-b px-4 py-2">
          <span className="mr-auto text-sm text-muted-foreground">{usuario?.email}</span>
          <Button variante="fantasma" tamanho="icone" onClick={alternar} aria-label="Alternar tema">
            {tema === "escuro" ? <Sun /> : <Moon />}
          </Button>
          <Button variante="fantasma" tamanho="icone" onClick={sair} aria-label="Sair">
            <LogOut />
          </Button>
        </header>
        <main className="min-w-0 flex-1 p-4 sm:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
